/* 🤖 this file was generated by svg-to-ts */
export const iconRainbowwallet: {
  name: 'rainbowwallet';
  data: string;
} = {
  name: 'rainbowwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m7.55 24.89h-8c-.74 0-1.33-.6-1.33-1.33 0-3.19-2.59-5.78-5.78-5.78-.74 0-1.33-.6-1.33-1.33v-8c0-.74.6-1.33 1.33-1.33 9.08 0 16.44 7.36 16.44 16.44 0 .74-.6 1.33-1.33 1.33"/></svg>`,
};
